import _Promise from 'babel-runtime/core-js/promise';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapState, mapMutations, mapActions } from 'vuex';
import { groupItemMixin } from '@/views/creative/mixin/index.js';
import categoryMixin from '@/views/creative/mixin/category.js';
import GroupLegend from '../components/group-legend.vue';
import Resource from '../components/resource.vue';
import ResourceList from '../components/resource-list.vue';
import AddResourceButton from './add-resource-button.vue';
import LanguageResource from './language-resource.vue';
import ToggleVisibleBtn from './toggle-visible-button.vue';
import CategoryMirror from './category-mirror.vue';
import ChangeVolumeBtn from './change-volume-btn.vue';
import AddResBtn from './add-res-btn.vue';
import RemoveResourceButton from './remove-resource-button.vue';
import ResListHandler from '../components/res-list-handler.vue';
import UpdateResourceButton from './update-resource-button.vue';
import EditResourceButton from './edit-resource-button.vue';
import isMaterialWarehouse from '@/common/is-warehouse.js';
import globalEventBus, { events } from '@/event';
import ResetResource from '../components/reset-resource.vue';
import StarButton from '../components/star-button.vue';
import DownloadResourceButton from './download-resource-button.vue';
import DownloadModelButton from './download-model-button.vue';
import UploadCoverButton from './upload-cover-button.vue';

import { isModelResource, isTextureResource } from '@/views/creative/utils';
import OrderListTips from '@/views/creative/template/order-list-tips.vue';

export default {
  props: {
    isSubCategory: {
      type: Boolean,
      default: false
    }
  },

  mixins: [groupItemMixin, categoryMixin],

  components: {
    OrderListTips: OrderListTips,
    GroupLegend: GroupLegend,
    Resource: Resource,
    ResourceList: ResourceList,
    AddResourceButton: AddResourceButton,
    LanguageResource: LanguageResource,
    ToggleVisibleBtn: ToggleVisibleBtn,
    ChangeVolumeBtn: ChangeVolumeBtn,
    AddResBtn: AddResBtn,
    RemoveResourceButton: RemoveResourceButton,
    ResListHandler: ResListHandler,
    UpdateResourceButton: UpdateResourceButton,
    EditResourceButton: EditResourceButton,
    CategoryMirror: CategoryMirror,
    ResetResource: ResetResource,
    StarButton: StarButton,
    DownloadResourceButton: DownloadResourceButton,
    DownloadModelButton: DownloadModelButton,
    UploadCoverButton: UploadCoverButton
  },

  data: function data() {
    return {
      loading: true
    };
  },


  computed: _extends({}, mapState({
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig;
    },
    currentCategory: function currentCategory(state) {
      return state.creative.template.currentCategory;
    },
    currentResource: function currentResource(state) {
      return state.creative.template.currentResource;
    },
    templateId: function templateId(state) {
      return state.creative.template.id;
    },
    editResourceDialog: function editResourceDialog(state) {
      return state.creative.template.editResourceDialog;
    },
    previewGroupConfig: function previewGroupConfig(state) {
      return state.creative.template.previewGroupConfig;
    },
    modelLoading: function modelLoading(state) {
      return state.creative.template.model.loading;
    },
    hasMvPlayable: function hasMvPlayable(state) {
      return state.creative.template.hasMvPlayable;
    },
    isInternalAccount: function isInternalAccount(state) {
      return state.user.info.is_internal_account;
    },
    isCommonTemplatePage: function isCommonTemplatePage(state) {
      return state.creative.template.isCommonTemplatePage;
    }
  }), {
    defaultResourceId: function defaultResourceId() {
      return (this.resourceList.find(function (item) {
        return item.is_default === 1;
      }) || {}).id;
    },
    innerResourceList: function innerResourceList() {
      // 如果是custom页面下，基础包中的初始资源如果被删除 deleted 为 1
      // 虽然界面不需要展示这个资源，但是资源信息不能被删除，因为实时预览时需要读取资源对应的信息, template 没有deleted=1的内容
      // action 等于 reset 不需要展示（重置坑位资源）
      return (this.resourceList || []).filter(function (item) {
        return item.action !== 'del' && item.deleted !== 1 && item.action !== 'reset';
      });
    },
    maxNumberOfResources: function maxNumberOfResources() {
      if (isMaterialWarehouse()) return 12;
      return 8;
    },


    /**
     * 是否允许编辑
     * 只有图片和 cocos 新版本的模型资源才允许编辑
     */
    resourceEditable: function resourceEditable() {
      return this.isImage || this.isModel && this.hasMvPlayable;
    },


    /**
     * 是否允许上传封面图
     * 只有图片和 cocos 新版本的模型资源才允许编辑
     */
    resourceUploadable: function resourceUploadable() {
      return this.isModel;
    },


    // 模型、模型贴图不展示上传按钮；
    hideUpload: function hideUpload() {
      return this.isModel && this.resourceList.length && isModelResource(this.resourceList[0]) || this.resourceList.length && isTextureResource(this.resourceList[0]);
    },


    // 模型/贴图仅限内部账号下载
    showDownload: function showDownload() {
      return this.isInternalAccount || isMaterialWarehouse() || !(this.isModel || this.resourceList.length && isTextureResource(this.resourceList[0]));
    }
  }),

  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.addResourceValidator();
    }, 0);
  },


  methods: _extends({}, mapMutations({
    updateCurrentCategory: 'creative/template/updateCurrentCategory',
    updateCurrentResource: 'creative/template/updateCurrentResource',
    openEditResourceDialog: 'creative/template/openEditResourceDialog',
    addValidator: 'creative/template/addValidator',
    updateCurrentResourceGroupTop: 'creative/template/updateCurrentResourceGroupTop',
    closeEditResourceDialog: 'creative/template/closeEditResourceDialog'
  }), mapActions({
    stopAudio: 'creative/template/previewer/stopAudio',
    recoveryAudio: 'creative/template/previewer/recoveryAudio',
    updateTargetCategory: 'creative/template/updateTargetCategory',
    resetResource: 'creative/template/resetResource'
  }), {
    handleUpdateTop: function handleUpdateTop() {
      this.updateCurrentResourceGroupTop(this.$refs.item.getBoundingClientRect().top);
    },
    handleSelectResource: function handleSelectResource(_ref) {
      var resource = _ref.resource;

      this.updateCurrentResource(resource);
      this.updateCurrentCategory(this.category);
    },
    handleDblSelectResource: function handleDblSelectResource(_ref2) {
      var resource = _ref2.resource;

      this.updateCurrentCategory(this.category);
      this.updateCurrentResource(resource);
      // 展开素材详情编辑弹窗时关闭样式编辑弹窗
      globalEventBus.$emit(events.DM.STYLE_EDITOR_POPOVER.CLOSE);
      this.openEditResourceDialog();
    },
    handleAudioPlay: function handleAudioPlay() {
      this.stopAudio();
    },
    handleAudioPause: function handleAudioPause() {
      this.recoveryAudio();
    },
    addResourceValidator: function addResourceValidator() {
      var _this2 = this;

      // 拥有选择默认资源的权限的业务才需要加是否选择了默认资源校验
      if (this.resourceList.length > 0) {
        this.addValidator({
          name: 'normal-group-item',
          validate: function validate() {
            return new _Promise(function (resolve, reject) {
              if (!_.isUndefined(_this2.defaultResourceId)) {
                resolve(true);
              } else {
                reject(new Error('Please select a default resource for category ' + _this2.category.name));
              }
            });
          }
        });
      }
    },
    handleReset: function handleReset(id) {
      this.resetResource({ categoryId: id });
    }
  })
};